import React from 'react'
const ItemAddIcon = () => (
  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.5 6.22179L0.5 7.77734L5.94445 7.77734L6.72222 6.99957L5.94445 6.22179L0.5 6.22179Z"
      fill="black"
    />
    <path
      d="M6.72569 14L8.28125 14L8.28125 8.55556L7.50347 7.77778L6.72569 8.55556L6.72569 14Z"
      fill="black"
    />
    <path
      d="M14.5 6.22179L14.5 7.77734L9.05555 7.77734L8.27778 6.99957L9.05555 6.22179L14.5 6.22179Z"
      fill="black"
    />
    <path
      d="M8.27431 2.71982e-07L6.71875 0L6.71875 5.44445L7.49653 6.22222L8.2743 5.44445L8.27431 2.71982e-07Z"
      fill="black"
    />
  </svg>
)
export default ItemAddIcon
